import React, { useContext, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import { Redirect } from "react-router";

import UIManager from "../../service/ui-manager";
import { Text, Gap, Img } from "../../comps";
import { NAVBAR } from "../../theme/dimensions";
import { Theme } from "../../theme/theme-provider";

import {
  navPlaylistSpotify,
  navPlaylistYoutube,
  importArt,
} from "../../theme/image";

const slideInRight = keyframes`
  0% { margin-left:${NAVBAR.FULL_WIDTH - NAVBAR.SIDE_WIDTH}px; }
  100% { margin-left:0px; }
`;

const hidden = keyframes`
  0% { opacity:0; }
  /* 99% { opacity:0;} */
  100% { opacity:0; }
`;

const PlaylistWrapper = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-left: 5px;
  padding-right: 5px;
  /* items centered in column */
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const OptionsWrapper = styled.div`
  width: 100%;
  flex-grow: 0;
  flex-shrink: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

const OptionItem = styled.div`
  width: 100%;
  height: 50px;
  flex-grow: 0;
  flex-shrink: 0;
  /* center */
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  justify-content: space-between;
  box-sizing: border-box;
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.color.BLACK_3};
  }
`;

const SmallIcon = styled(Img)`
  width: ${({ width }) => width + "px"};
  height: ${({ height }) => (height ? height + "px" : `auto`)};
  box-sizing: border-box;
  ${(props) => {
    return (
      props.opacity &&
      css`
        opacity: ${props.opacity};
      `
    );
  }}
  ${OptionItem}:hover & {
    opacity: 1;
  }
`;

const AnimatedOptionItem = styled(OptionItem)`
  opacity: 1;
  animation: ${({ delay }) => (delay ? delay + "s" : "")} ${hidden} linear,
    0.2s ${({ delay }) => (delay ? delay + "s" : "")} ${slideInRight} linear;
`;

const Tagline = styled(Text)`
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 20px;
`;

const getOptions = (setRedirect) => {
  return [
    {
      id: 1,
      name: "Import From Spotify",
      icon: navPlaylistSpotify,
      onClick: () => {
        setRedirect("/import");
        UIManager.collapsePlayer();
      },
    },
    {
      id: 2,
      name: "Import From Youtube",
      icon: navPlaylistYoutube,
      onClick: () => {
        setRedirect("/import");
        UIManager.collapsePlayer();
      },
    },
  ];
};

const Option = ({ pos, option: { id, name, icon, onClick } }) => {
  const delay = ((pos + 1) * 1.0) / 10;

  return (
    <AnimatedOptionItem onClick={onClick} delay={delay} key={id}>
      <Text
        color={Theme.color.GRAY_1}
        fontSize={`13px`}
        fontWeight={600}
        onHoverColor={Theme.color.GRAY_1}
      >
        {name}
      </Text>
      {icon && <SmallIcon src={icon} width={18} height={18} opacity={0.5} />}
    </AnimatedOptionItem>
  );
};

export default () => {
  const [redirectTo, setRedirect] = useState("");
  const availWidth = NAVBAR.FULL_WIDTH - NAVBAR.SIDE_WIDTH;
  const artWidth = availWidth - 60;
  const options = getOptions(setRedirect);

  return (
    <PlaylistWrapper>
      <Img
        style={{ opacity: 0.6 }}
        src={importArt}
        width={availWidth}
        alt="image"
      />
      <Tagline
        fontSize={"13px"}
        fontWeight={600}
        textAlign={`center`}
        color={Theme.color.GRAY_1}
      >{`Import songs from your youtube/spotify playlists`}</Tagline>
      <Gap height={20} />
      <OptionsWrapper>
        {options.map((option, pos) => {
          return <Option key={option.id} pos={pos} option={option} />;
        })}
        {redirectTo && <Redirect push to={redirectTo} />}
      </OptionsWrapper>
    </PlaylistWrapper>
  );
};
